import { ReactElement, SVGProps } from 'react';
import BaseIcon from './BaseIcon';

export default function ChartLineIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props} viewBox="0 0 22 17">
      <path
        d="M2 17q-.824 0-1.412-.587A1.93 1.93 0 0 1 0 15q0-.825.588-1.412A1.93 1.93 0 0 1 2 13h.263a.6.6 0 0 1 .237.05L7.05 8.5A.6.6 0 0 1 7 8.262V8q0-.824.588-1.412A1.93 1.93 0 0 1 9 6q.825 0 1.412.588Q11 7.175 11 8q0 .05-.05.5l2.55 2.55a.6.6 0 0 1 .238-.05h.524a.6.6 0 0 1 .238.05l3.55-3.55a.6.6 0 0 1-.05-.237V7q0-.824.587-1.412A1.93 1.93 0 0 1 20 5q.824 0 1.413.588Q22 6.175 22 7q0 .824-.587 1.412A1.93 1.93 0 0 1 20 9h-.262a.6.6 0 0 1-.238-.05l-3.55 3.55a.6.6 0 0 1 .05.238V13q0 .825-.588 1.412A1.93 1.93 0 0 1 14 15q-.825 0-1.412-.588A1.93 1.93 0 0 1 12 13v-.262a.6.6 0 0 1 .05-.238L9.5 9.95a.6.6 0 0 1-.238.05H9q-.05 0-.5-.05L3.95 14.5a.6.6 0 0 1 .05.238V15q0 .824-.587 1.413A1.93 1.93 0 0 1 2 17M3 6.975l-.625-1.35L1.025 5l1.35-.625L3 3.025l.625 1.35L4.975 5l-1.35.625zM14 6l-.95-2.05L11 3l2.05-.95L14 0l.95 2.05L17 3l-2.05.95z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
